import { useCallback, useEffect, useState } from "react";

import { fetchOperationalDashboard } from "../services/crmOperationalDashboard.service";
import type { OperationalDashboardViewModel } from "../utils/crmOperationalDashboard.aggregate";

export type UseCrmOperationalDashboardResult = {
  loading: boolean;
  error: Error | null;
  lastFetchedAt: number | null;
  refresh: () => Promise<void>;
  model: OperationalDashboardViewModel | null;
};

export function useCrmOperationalDashboard(): UseCrmOperationalDashboardResult {
  const [model, setModel] = useState<OperationalDashboardViewModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [lastFetchedAt, setLastFetchedAt] = useState<number | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setModel(await fetchOperationalDashboard());
      setLastFetchedAt(Date.now());
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
      setModel(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { loading, error, lastFetchedAt, refresh: load, model };
}
